import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { selectAuthState } from '../../store/auth/auth.selector';

export const loginGuard = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(selectAuthState).pipe(
    filter(state => state.sessionChecked), take(1),
    map(state => state.isAuthenticated ? router.createUrlTree(['/']) : true),
  );
};
